import { render, staticRenderFns } from "./gjxx.vue?vue&type=template&id=337e5a42&scoped=true&"
import script from "./gjxx.vue?vue&type=script&lang=js&"
export * from "./gjxx.vue?vue&type=script&lang=js&"
import style0 from "./gjxx.vue?vue&type=style&index=0&id=337e5a42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337e5a42",
  null
  
)

export default component.exports